import { type TooltipProps, Tooltip as TooltipV5 } from 'antd5';
import { type CSSProperties, useTheme } from 'styled-components';

import { StyledQuestionCircleOutlined } from './Tooltip.style';

export const Tooltip = (props: TooltipProps) => {
  const theme = useTheme();
  return <TooltipV5 color={theme.tooltipBackground} {...props} />;
};

export const TooltipWithQuestionIcon = ({
  message,
  iconStyle,
}: {
  message: JSX.Element | string;
  iconStyle?: CSSProperties;
}) => {
  return (
    <Tooltip style={{ margin: '0 0.5rem' }} title={message}>
      <StyledQuestionCircleOutlined style={iconStyle} />
    </Tooltip>
  );
};
